import Request from "../../lib/request";
import {
  HASHTAG_LIST_API,
  HASHTAG_SUMMARY_API,
  PROJECT_USERS_API,
  REPORTS_API
} from "../../constants/api";
import { PROJECT_USER_ID } from "../../constants/storageKeys";
import { PAGE } from "../../constants/filters";

const baseUrl = process.env.REACT_APP_API_ADMIN_URL;

export const getSummaryList = (page_number, finalFilter) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${REPORTS_API}/${HASHTAG_SUMMARY_API}?${PAGE}=${page_number}`,
    needToken: true,
    data: finalFilter
  });
};

export const getAllList = (page_number, finalFilter) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${REPORTS_API}/${HASHTAG_LIST_API}?${PAGE}=${page_number}`,
    needToken: true,
    data: finalFilter
  });
};
